import React from "react";
import { GraduationCap, Building2, Shield, GitBranch, Music2, Quote, Tag } from "lucide-react";
import SectionHeading from "./SectionHeading";

const ICONS = { GraduationCap, Building2, Shield, GitBranch };

const Note = ({ icon: Icon, children, testId }) => (
  <div data-testid={testId} className="flex gap-4 p-5 rounded-2xl border border-[#1E90FF]/15 bg-[#0D1117]">
    <Icon size={18} className="shrink-0 mt-0.5 text-[#1E90FF]" />
    <div className="text-sm text-[#C8CED8] leading-relaxed">{children}</div>
  </div>
);

const CoachingTrust = ({ t }) => (
  <section id="trust" data-testid="coaching-trust" className="relative py-16 md:py-24 bg-[#070A12] scroll-mt-16">
    <div className="max-w-6xl mx-auto px-5 lg:px-10">
      <SectionHeading index="03" title={t.credentialsTitle} subtitle={t.credentialsIntro} />

      <div className="mt-10 md:mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {t.credentialsItems.map((c) => {
          const Icon = ICONS[c.icon];
          return (
            <div key={c.title} className="bb-card rounded-2xl p-5 md:p-6">
              <span className="w-10 h-10 rounded-xl bg-[#1E90FF]/10 border border-[#1E90FF]/30 flex items-center justify-center">
                <Icon size={18} className="text-[#1E90FF]" />
              </span>
              <div className="mt-4 font-mono text-[10px] tracking-[0.25em] text-[#A1A7B3] uppercase">{c.title}</div>
              <p className="mt-1.5 text-sm md:text-base text-[#F3F6FA] leading-snug">{c.body}</p>
            </div>
          );
        })}
      </div>

      <div className="mt-6 grid lg:grid-cols-3 gap-4 md:gap-5">
        <Note icon={Music2} testId="coaching-teaching-note">{t.teachingNote}</Note>
        <Note icon={Quote} testId="coaching-recommendation-note">
          {t.recommendationNote}{" "}
          <a href="/#recommendations" data-testid="coaching-recommendation-link" className="text-[#1E90FF] hover:underline">
            {t.ui.recommendationLink} →
          </a>
        </Note>
        <Note icon={Tag} testId="coaching-pricing">
          <span className="block font-semibold text-[#F3F6FA] mb-1">{t.pricing.title}</span>
          {t.pricing.body}
        </Note>
      </div>
    </div>
  </section>
);

export default CoachingTrust;
